import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Declare the gtag function on the window object
declare global {
    interface Window {
        gtag: (
            command: 'config' | 'event' | 'js',
            targetId: string,
            config?: Record<string, any>
        ) => void;
        dataLayer: any[];
    }
}

export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        // Check if gtag exists (it should be loaded from index.html)
        if (typeof window.gtag !== 'undefined') {
            window.gtag('event', 'page_view', {
                page_path: location.pathname + location.search,
                page_title: document.title,
            });
        }
    }, [location]);
};
